import { useState, useEffect } from 'react';
import PaymentSessionService from '../services/http/paymentSessionService';
import { PaymentEntryPayload } from '../shared/interfaces/payment.interface';

interface SessionData {
  invoiceNumber: string;
  totalInvoice: number;
  customerName: string;
  cardMaxInstallmentNumber: number;
  paymentMethod: string;
  status: string;
  boletoUrl: string | null;
  paymentDeadline: string;
  expired: boolean;
}

export const usePaymentSession = (sessionToken: string) => {
  const [sessionData, setSessionData] = useState<SessionData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [isProcessing, setIsProcessing] = useState(false);

  useEffect(() => {
    const validateSession = async () => {
      try {
        setLoading(true);
        const data = await PaymentSessionService.validateSession(sessionToken);
        setSessionData(data);
        setError(null);
      } catch (err: any) {
        const statusCode = err?.statusCode ?? err?.response?.status;
        setError(
          statusCode === 401
            ? 'Link expirado ou inválido'
            : err?.message || 'Erro ao carregar dados do pagamento'
        );
        setSessionData(null);
      } finally {
        setLoading(false);
      }
    };

    if (sessionToken) {
      validateSession();
    }
  }, [sessionToken]);

  const processPayment = async (payments: PaymentEntryPayload[]) => {
    try {
      setIsProcessing(true);
      const result = await PaymentSessionService.checkout(sessionToken, payments);
      return result;
    } finally {
      setIsProcessing(false);
    }
  };

  return {
    sessionData,
    loading,
    error,
    isProcessing,
    processPayment,
  };
};

export default usePaymentSession;
